import { render } from "./TradePairToggle.vue?vue&type=template&id=71d29c1e&scoped=true&ts=true"
import script from "./TradePairToggle.vue?vue&type=script&lang=ts"
export * from "./TradePairToggle.vue?vue&type=script&lang=ts"

import "./TradePairToggle.vue?vue&type=style&index=0&id=71d29c1e&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d29c1e"]])

export default __exports__